import loi from "./loi/de"

export default {
  loi,
};
